module.exports = __webpack_public_path__ + "img/symbol_8.49589f0e.png";